import { render, staticRenderFns } from "./cadastrar-conta-banco.vue?vue&type=template&id=5735b44d&scoped=true&"
import script from "./cadastrar-conta-banco.vue?vue&type=script&lang=js&"
export * from "./cadastrar-conta-banco.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar-conta-banco.vue?vue&type=style&index=0&id=5735b44d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5735b44d",
  null
  
)

export default component.exports